import { MultiSelect, SimpleSelect, SwitchInput } from 'corso-admin-ui';
import { InventoryBehavior, isTruthy } from 'corso-types';
import { Controller } from 'react-hook-form';
import { inventoryBehaviorLabels } from '~/types';
import { useAutomationFormContext } from '../hooks/useAutomationForm';
import useFulfillmentLocations from '../hooks/useFulfillmentLocations';

export default function EventAutoFinalizeClaimSettings() {
  const { control } = useAutomationFormContext();

  const locations = useFulfillmentLocations();

  const locationOptions =
    locations.data?.map((location) => ({
      value: `${location.id}`,
      label: location.name,
    })) ?? [];

  return (
    <>
      <Controller
        control={control}
        name="event.params.failOnOutOfStockScenarios"
        defaultValue={false} // prevent uncontrolled input warning
        render={({ field: { onChange, value }, fieldState }) => (
          <SwitchInput
            id="fail-on-out-of-stock-scenarios"
            label="Fail on Out of Stock Scenarios"
            details="Fail to finalize the claim if the item is out of stock."
            checked={value}
            onChange={(event) => {
              onChange(event);
            }}
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="event.params.allowFulfillmentLocationIds"
        render={({ field, fieldState }) => (
          <MultiSelect
            label="Allowed Fulfillment Locations"
            details="Only finalize the claim if inventory is available at one of these fulfillment locations. Leave empty to allow any location."
            placeholder="Select Fulfillment Locations"
            options={locationOptions}
            value={(field.value ?? [])
              .map((id) =>
                locationOptions.find((option) => option.value === `${id}`),
              )
              .filter(isTruthy)}
            onChange={(selections) =>
              field.onChange(
                selections.map((selection) =>
                  Number.parseInt(selection.value, 10),
                ),
              )
            }
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="event.params.inventoryBehavior"
        render={({ field, fieldState }) => (
          <SimpleSelect
            label="Inventory Behavior"
            details="The Shopify inventory behavior to apply when finalizing a claim that results in a new order. Overrides the store's default Inventory Behavior setting when set; leave unset to use the store default."
            options={Object.values(InventoryBehavior).map((action) => ({
              value: action,
              label: inventoryBehaviorLabels[action],
            }))}
            onChange={field.onChange}
            value={field.value}
            error={fieldState.error?.message}
          />
        )}
      />
    </>
  );
}
